module.exports = __webpack_public_path__ + "img/datacount.007ad548.png";